export default {
  top_container: {
    slogan: 'Global Exhibition Booth Reservation, Ticket Reservation',
    inputPlaceholder: 'Country, City, Industry, Exhibition Name'
  },
  hot_city: {
    title: 'Popular exhibition city：',
    city1: 'Shanghai',
    city2: 'Shenzhen',
    city3: 'Guangzhou',
    city4: 'Beijing',
    city5: 'Hong Kong',
    city6: 'Germany',
    city7: 'Japan',
    city8: 'America',
    city1_hover: 'Shanghai Exhibition',
    city2_hover: 'Shenzhen Exhibition',
    city3_hover: 'Guangzhou Exhibition',
    city4_hover: 'Beijing Exhibition',
    city5_hover: 'Hong Kong Exhibition'
  },
  kindTitle: 'Exhibition industry classification',
  hot_recommend: {
    hot_title: 'Recommend popular exhibitions',
    moreButton: 'More',
    international_hover: 'International exhibition',
    domestic_hover: 'Domestic exhibition',
    internationalTitle: 'International exhibition·Be about to start',
    domesticTitle: 'Domestic exhibition·Be about to start',
    distance: 'Starts: ',
    day: 'days',
    openness: 'Under way...',
    timeUpdate: 'Waiting update time...',
    newTrends_title: 'Latest news',
    exhibitionInfo_hover: 'Exhibition information',
    nuwInfo_title: 'Latest news',
    newExhibition_title: 'Latest exhibition',
    hot_country_title: 'Hot country',
    country_suffix3: 'exhibition',
    country_suffix2: 'exhibition',
    country_suffix1: 'exhibition',
    service_1: 'Global exhibition resources',
    service_2: 'Dedicated service consultant',
    service_3: 'One-stop service',
    service_4: 'Fast and accurate matching',
    service_5: 'It covers 99 countries'
  },
  popularRegions: 'Popular Regions',
  hotIndustries: 'Hot Industries',
  topExhibitions: 'Top Exhibitions'
}
